var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-qrcode"},[_c('QrcodeVue',{attrs:{"value":_vm.qrcodeSrc,"size":_vm.qrcodeSize,"level":"H"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }